<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>{{ context.pageTitle | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <!-- No glxy-page-wrapper: the content fills the page main area so each table
       manages its own internal scroll (search / headers / paginator stay visible). -->
  <div class="page-content">
    <mat-tab-group
      class="knowledge-tabs"
      animationDuration="0ms"
      [mat-stretch-tabs]="false"
      [selectedIndex]="activeTab() === 'bases' ? 1 : 0"
      (selectedIndexChange)="onTabChange($event === 1 ? 'bases' : 'sources')"
    >
      <mat-tab [label]="context.sourcesTabLabel ?? 'KNOWLEDGE_SHARING.TABS.SOURCES' | translate">
        <ai-knowledge-knowledge-source-table
          [dataSource]="ksDataSource"
          [rows]="ksRowsData()"
          [editingEnabled]="editingEnabled()"
          [rawSourcesById]="rawSourcesById()"
          (changed)="onSourcesChanged()"
        />
      </mat-tab>

      <mat-tab [label]="context.basesTabLabel ?? 'KNOWLEDGE_SHARING.TABS.COLLECTIONS' | translate">
        <ai-knowledge-knowledge-base-table
          [dataSource]="kbDataSource"
          [sources]="ksRowsData()"
          [sourcesLoader]="fetchOwnedSourceRows"
          [editingEnabled]="editingEnabled()"
          [canShare]="canShareEffective()"
          [persist]="persistChanges()"
          [shareAsTopLevelAction]="shareAsTopLevelAction"
          [openDetailOnRowClick]="openDetailOnRowClick"
          (kbCreated)="onKbCreated($event)"
          (kbSourcesChanged)="onKbSourcesChanged($event)"
          (kbDeleted)="onKbDeleted($event)"
          (openDetail)="openKbDetail.emit($event)"
        />
      </mat-tab>
    </mat-tab-group>
  </div>
</glxy-page>
